<template>
    <div class="modal-body dialog-no-indent-top dialog-no-indent-right full-height loading-background">
        <div class="full-height center-align">
            <iframe :id="cromiFrameId"
                    title="Crom"
                    class="survey-width full-height grey-border"
                    :src="iframeSrc" />
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, defineProps, defineEmits, onMounted } from 'vue';
    import { modalDialog } from '../../js/ModalDialog.js';

    window.onmessage = function (e) {
        if (e.data == crom_window_message.value) {
            close();
        }
    };

    const props = defineProps({
        dialogId: {
            type: String,
            default: "crom-iframe"
        },
        patientGuid: {
            type: String,
            required: true
        },
        specificItemId: {
            type: Number,
            required: true
        },
        specificItemType: {
            type: Number,
            required: true
        },
        surveyId: {
            type: Number,
            required: true
        },
    });

    const emit = defineEmits(['completed']);

    const cromiFrameId = computed(() => `${props.dialogId}-iframe`);

    const crom_window_message = ref("");
    const iframeSrc = ref("");


    // 0 = scheduled, 1 = complete, 2 = incomplete, 10 = Create if new
    onMounted(() => {
        if (props.patientGuid) {
            crom_window_message.value = `ecaptis_survey_complete_${props.patientGuid.slice(0, 8)}_${props.surveyId}`;
            let url = "";

            if (props.specificItemType == 2 /* incomplete */) {
                url = `/Response/ShowCromSurveyIncomplete?incompleteItemId=${props.specificItemId}&surveyId=${props.surveyId}&patientGuid=${props.patientGuid}`;
            } else if (props.specificItemType == 10 /* create if new */) {
                url = `/Response/ShowCROMSurveyAddIfNeeded?surveyid=${props.surveyId}&patientGuid=${props.patientGuid}`;
            } else {
                url = `/Response/ShowCromSurveyScheduled?scheduledItemId=${props.specificItemId}&surveyId=${props.surveyId}&patientGuid=${props.patientGuid}`;
            }
            iframeSrc.value = url;
        }
    });

    function close() {
        emit("completed");
    }

</script>